import React from 'react';
import Common from './Component';
const Home=()=>{
    return (
        <Common name="Grow Your Business with " imgsrc={`https://images.unsplash.com/photo-1509966756634-9c23dd6e6815?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=410&q=80`} visit="/service" btnname="Get Started"/>
    )
}

export default Home;